import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import UserFileUploadForm from "./UserFileUploadForm";
import {useGetRoles} from "../../api/users/useRoles";
import {useInvite} from "../../api/users/useInvite";

function UserFileUploadModal(props: {
    tenantId: number | undefined
    title: string
    buttonTitle: string
    callback?: () => void
}) {
    const [show, setShow] = useState(false);
    const {loading: loadingRoles, data: dataRoles = [], error: errorRoles, execute: executeRoles} = useGetRoles();
    const {loading: loadingInvite, error: errorInvite, execute: executeInvite} = useInvite();

    useEffect(() => {
        if (props.tenantId && show) {
            executeRoles(props.tenantId);
        }
    }, [props.tenantId, show]);

    if(!props.tenantId) {
        return (<></>);
    }

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleInvite = async (roleId: number, emails: string[]) => {
        await executeInvite(props.tenantId!!, {roleId, emails});
    };

    const handleSuccess = () => {
        if (props.callback) {
            props.callback();
        }
        handleClose();
    };

    return (
        <div>
            <Button variant="primary" onClick={handleShow}>
                {props.buttonTitle}
            </Button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UserFileUploadForm
                        tenantId={props.tenantId}
                        roles={dataRoles}
                        onInvite={handleInvite}
                        onSuccess={handleSuccess}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default UserFileUploadModal;